import {
  buildConversacionTwilioIA,
  copiarTextoPortapapeles,
  descargarJson,
} from '@/utils/exportarConversacionTwilioIA'

export default {
  data () {
    return {
      dialogJsonConversacionIA: false,
      jsonConversacionIA: '',
      origenExportConversacionIA: '',
      exportandoUltimasConversaciones: false,
      cargandoDebugExportV2: false,
    }
  },

  computed: {
    puedeExportarConversacionIA () {
      const id = Number(this.getdatosUsuarioERPERP.iderp)
      return id === 334 || id === 1 || id === 3176
    },
  },

  methods: {
    /**
     * Carga estado + traces debug V2 desde API (best-effort; no bloquea export).
     */
    async fetchDebugExportV2 (chat) {
      const usuario = chat && chat.usuario
      if (!usuario || !this.$http) {
        return {
          estado_orquestador_v2: null,
          trace_turnos_v2: [],
          diagnostico_v2: null,
          debug_meta: { fuente: 'sin_peer', turnos_guardados: 0 },
        }
      }
      try {
        const { data } = await this.$http.post('vendedor-ia.export-debug', {
          fuente: 'produccion',
          usuario,
          peer: usuario,
          twilio: (chat && chat.numeroTwilio) || null,
        })
        return {
          estado_orquestador_v2: (data && data.estado_orquestador_v2) || null,
          trace_turnos_v2: (data && Array.isArray(data.trace_turnos_v2)) ? data.trace_turnos_v2 : [],
          diagnostico_v2: (data && data.diagnostico_v2) || null,
          debug_meta: (data && data.debug_meta) || null,
        }
      } catch (error) {
        return {
          estado_orquestador_v2: null,
          trace_turnos_v2: [],
          diagnostico_v2: null,
          debug_meta: {
            fuente: 'error_fetch',
            turnos_guardados: 0,
            error: (error && error.message) || 'fetch_failed',
          },
        }
      }
    },

    async construirPayloadConversacionIA (origen, chat, mensajes) {
      const debug = await this.fetchDebugExportV2(chat)
      return buildConversacionTwilioIA({
        origen,
        chat,
        mensajes,
        alumno: this.alumno,
        asignacion: this.asignacion,
        analysisIA: this.analysisIA || null,
        estadoOrquestadorV2: debug.estado_orquestador_v2,
        traceTurnosV2: debug.trace_turnos_v2,
        diagnosticoV2: debug.diagnostico_v2,
        debugMeta: debug.debug_meta,
      })
    },

    async abrirJsonConversacionIA (origen) {
      if (!this.chat || !Array.isArray(this.mensajes) || !this.mensajes.length) {
        this.validarError('No hay mensajes en esta conversación')
        return
      }

      this.cargandoDebugExportV2 = true
      try {
        const payload = await this.construirPayloadConversacionIA(origen, this.chat, this.mensajes)
        this.origenExportConversacionIA = origen
        this.jsonConversacionIA = JSON.stringify(payload, null, 2)
        this.dialogJsonConversacionIA = true
      } finally {
        this.cargandoDebugExportV2 = false
      }
    },

    async copiarJsonConversacionIA () {
      try {
        await copiarTextoPortapapeles(this.jsonConversacionIA)
        this.validarSuccess('JSON copiado al portapapeles')
      } catch (error) {
        this.validarError('No se pudo copiar el JSON')
      }
    },

    descargarJsonConversacionIA () {
      const folio = (this.chat && this.chat.folio) || 'sin_folio'
      const contacto = String((this.chat && this.chat.usuario) || 'contacto')
        .replace(/[^\d+]/g, '')
      const nombre = `conversacion_${this.origenExportConversacionIA}_${folio}_${contacto}.json`
      descargarJson(this.jsonConversacionIA, nombre.replace(/\s+/g, '_'))
    },

    /** Descarga el JSON de la conversación sin abrir el diálogo. */
    async descargarConversacionIADirecto (origen) {
      if (!this.chat || !Array.isArray(this.mensajes) || !this.mensajes.length) {
        this.validarError('No hay mensajes en esta conversación')
        return
      }

      this.cargandoDebugExportV2 = true
      try {
        const payload = await this.construirPayloadConversacionIA(
          origen || 'twilio',
          this.chat,
          this.mensajes,
        )
        this.origenExportConversacionIA = origen || 'twilio'
        this.jsonConversacionIA = JSON.stringify(payload, null, 2)
        this.descargarJsonConversacionIA()
        this.validarSuccess('Conversación descargada')
      } finally {
        this.cargandoDebugExportV2 = false
      }
    },

    /**
     * Descarga las N conversaciones más recientes en un solo JSON.
     * @param {{ origen?: string, limite?: number, chats?: Array, fetchMensajes: Function }} opts
     */
    async descargarUltimasConversacionesIA ({
      origen = 'twilio-agente',
      limite = 20,
      chats = [],
      fetchMensajes,
    } = {}) {
      if (this.exportandoUltimasConversaciones) return
      if (typeof fetchMensajes !== 'function') {
        this.validarError('No se pudo preparar la descarga')
        return
      }

      const lista = (Array.isArray(chats) ? chats : []).slice(0, Math.max(1, Number(limite) || 20))
      if (!lista.length) {
        this.validarError('No hay conversaciones para descargar')
        return
      }

      this.exportandoUltimasConversaciones = true
      try {
        const conversaciones = []
        const errores = []

        for (const chat of lista) {
          let mensajes = []
          try {
            mensajes = await fetchMensajes(chat)
            if (!Array.isArray(mensajes)) mensajes = []
          } catch (error) {
            errores.push({
              contacto: String((chat && chat.usuario) || ''),
              message: (error && error.response && error.response.data && error.response.data.message)
                || (error && error.message)
                || 'Error al obtener mensajes',
            })
          }

          const debug = await this.fetchDebugExportV2(chat)
          conversaciones.push(buildConversacionTwilioIA({
            origen,
            chat,
            mensajes,
            alumno: null,
            asignacion: null,
            analysisIA: null,
            estadoOrquestadorV2: debug.estado_orquestador_v2,
            traceTurnosV2: debug.trace_turnos_v2,
            diagnosticoV2: debug.diagnostico_v2,
            debugMeta: debug.debug_meta,
          }))
        }

        const stamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19)
        const payload = {
          meta: {
            origen,
            exportado_en: new Date().toISOString(),
            limite_solicitado: limite,
            total_exportadas: conversaciones.length,
            errores: errores.length ? errores : undefined,
          },
          conversaciones,
        }

        descargarJson(
          JSON.stringify(payload, null, 2),
          `ultimas_${conversaciones.length}_conversaciones_${origen}_${stamp}.json`,
        )

        if (errores.length) {
          this.validarError(`Descargadas ${conversaciones.length}; ${errores.length} con error de mensajes`)
        } else {
          this.validarSuccess(`${conversaciones.length} conversaciones descargadas`)
        }
      } catch (error) {
        this.validarError((error && error.message) || 'No se pudo descargar el JSON')
      } finally {
        this.exportandoUltimasConversaciones = false
      }
    },
  },
}
